// Copyright (c) Bentley Systems
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

type themeState = {
  isDark: boolean;
};

const initialState: themeState = {
  isDark: false,
};

export const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setTheme: (state, action: PayloadAction<boolean>) => {
      state.isDark = action.payload;
    },
  },
});

export const { setTheme } = themeSlice.actions;

export const selectTheme = (state: RootState) => state.theme;

export default themeSlice.reducer;
